<template>
  <v-tooltip top color="grey lighten-1">
    <template v-slot:activator="{ on, attrs }">
      <v-btn icon v-bind="attrs" v-on="on" @click="trashBtnClick">
        <v-icon small color="grey lighten-1">mdi-trash-can-outline</v-icon>
      </v-btn>
    </template>
    <span>
      {{ tooltipText }}
    </span>
  </v-tooltip>
</template>

<script>
export default {
  name: 'TrashCanBtn',
  props: {
    tooltipText: String,
  },
  methods: {
    trashBtnClick() {
      this.$emit('trash-btn-click');
    },
  },
};
</script>
